import React, { useEffect, useRef } from "react";
import Header from "./Components/Header";
import "./CaseStudies.css";
import Footer from "./Components/Footer";
import { useLocation } from "react-router-dom";



const CaseStudies = () => {
  const location = useLocation();

  const caseStudyPageRefs = {
    "caseStudyBanner": useRef(),
  };

  useEffect(() => {
    let ref = caseStudyPageRefs[location.state?.scrollTo];
    if (ref && ref.current) {
      const y = ref.current.getBoundingClientRect().top + window.pageYOffset - 150;
      window.scrollTo({ top: y, behavior: "smooth" });
    }
  //eslint-disable-next-line
  }, [location]);

  return (
    <React.Fragment>
    <Header />

    <div ref={caseStudyPageRefs.caseStudyBanner} className="case-study-banner-container">
        <div className="case-study-banner-title-container">
            <span className="case-study-banner-title">
                Energy Optimization
            </span>
            <span className="case-study-banner-sub-title">
                Smarter energy for every compressor
            </span>
        </div>
        <div className="case-study-banner-parent-container">
            <div className="case-study-banner-child-container">
            <span className="case-study-banner-info1">
                Kompress.ai helps you measure and reduce the real energy cost of compressed air. It connects compressors, dryers, flow meters, and energy meters to uncover hidden losses.
            </span>
            <span className="case-study-banner-info2">
                Kompress.ai shows how your compressed air system consumes energy, helping you cut waste, boost efficiency, and reduce emissions.
            </span>
            {/* <span className="case-study-banner-info1">
                Kompress.ai helps industries see, measure, and reduce the true cost of compressed air. By connecting compressors, dryers, flow meters, and energy meters, the platform reveals hidden energy losses and helps you run your system at peak efficiency.
            </span>
            <span className="case-study-banner-info2">
                Every compressor. Every kilowatt. Every emission. Kompress.ai brings them together in one intelligent view that tracks power, pressure, and flow in real time and converts performance data into actionable savings.
            </span> */}
            <div className="case-study-banner-btn-container">
                {/* <button className="case-study-banner-insights-btn">
                    See Real Time insights
                </button> */}
                <button
                onClick={() => {
                    window.location.href="mailto:sales@utvyakta.com"
                }}
                className="case-study-banner-team-btn">
                    Talk to Our Team
                </button>
            </div>
            </div>
            <div className="case-study-banner-img-container">
                <img src={require("./images/energy_optimization.png")} alt=""/>
            </div>
        </div>

    </div>

    <div className="case-study-energy-oppurtunity-container">
        <div className="case-study-energy-oppurtunity-child-container">
            <div className="case-study-energy-oppurtunity-child-left-container">
                <span className="case-study-energy-oppurtunity-child-left-title">
                    The Hidden Energy Opportunity
                </span>
                {/* <span className="case-study-energy-oppurtunity-child-left-info1">
                    Compressed air can consume up to 30 percent of a plant's total power, yet most facilities have limited visibility into how that energy is used. Leaks, idle running, and unbalanced pressure can silently drain thousands of kilowatt-hours every year.
                </span>
                <span className="case-study-energy-oppurtunity-child-left-info2">
                    Kompress.ai helps you uncover these hidden inefficiencies. By continuously tracking energy use, load cycles, and flow, it highlights where power is being wasted and how efficiency can be improved.
                </span> */}
                <span className="case-study-energy-oppurtunity-child-left-info1">
                    <b>Energy Insight:</b> Compressed air can use up to 30% of your plant’s power. Kompress.ai gives you the clarity to reduce it.
                </span>
                <span className="case-study-energy-oppurtunity-child-left-info2">
                    <b>Smart Optimization:</b> It tracks power and flow, detects leaks, and measures your carbon impact, verifying every improvement in real time.
                </span>
                <span className="case-study-energy-oppurtunity-child-left-sub-title">
                    What was once invisible now becomes measurable and manageable.
                </span>
            </div>
            <div className="case-study-energy-oppurtunity-child-right-container">
                <span className="case-study-energy-oppurtunity-child-right-title">
                    Energy Waste Indicators
                </span>
                <div className="case-study-energy-oppurtunity-child-right-content-container">
                    {[
                        {
                            "title": "Air Leaks",
                            "info": "Undetected system leaks",
                            "count": "Up to 40% loss",
                        },
                        {
                            "title": "Idle Running",
                            "info": "Compressors running without load",
                            "count": "20-30% waste",
                        },
                        {
                            "title": "Poor Sequencing",
                            "info": "Uncoordinated compressor operation",
                            "count": "15-25% loss",
                        },
                        {
                            "title": "Pressure Issues",
                            "info": "Excessive or unstable pressure",
                            "count": "10-20% waste",
                        }
                    ].map((data, i) => {
                        return (
                            <div
                            className={`case-study-energy-oppurtunity-child-right-content-parent
                            ${i === 0 ? "right-content-parent-red" : ""}
                            ${i === 1 ? "right-content-parent-yellow" : ""}
                            ${i === 2 ? "right-content-parent-orange" : ""}
                            ${i === 3 ? "right-content-parent-purple" : ""}
                            `}>
                                <div className="case-study-energy-oppurtunity-child-right-content-parent-title-container">
                                    <span className="case-study-energy-oppurtunity-child-right-content-parent-title">{data.title}</span>
                                    <span
                                    className={`case-study-energy-oppurtunity-child-right-content-parent-count
                                    ${i === 0 ? "right-content-count-red" : ""}
                                    ${i === 1 ? "right-content-count-yellow" : ""}
                                    ${i === 2 ? "right-content-count-orange" : ""}
                                    ${i === 3 ? "right-content-count-purple" : ""}
                                    `}>
                                        {data.count}
                                    </span>
                                </div>
                                <span className="case-study-energy-oppurtunity-child-right-content-parent-info">{data.info}</span>
                            </div>
                        )
                    })
                    
                    }
                </div>
            </div>
        </div>
    </div>

    <div className="case-study-delivers-container">
        <div className="case-study-delivers-child-container">
            <div className="case-study-delivers-child-title-container">
                <span className="case-study-delivers-container-title">
                    How Kompress.ai Delivers Measurable Savings
                </span>
                <span className="case-study-delivers-container-sub-title">
                    Kompress.ai transforms compressor data into real-time intelligence that leads directly to energy savings.
                </span>
            </div>
            <div className="case-study-delivers-child-content-container">
                <span className="case-study-delivers-content-title">
                    Key Capabilities
                </span>
                <div className="case-study-delivers-content-parent">
                    {[
                        {
                            "title": "Continuous Tracking",
                            "info": "Tracks compressor power, pressure, and flow continuously",
                        },
                        {
                            "title": "Leak Detection",
                            "info": "Detects leaks, idle hours, and poor load-to-unload ratios",
                        },
                        {
                            "title": "Precise Benchmarking",
                            "info": "Calculates specific power consumption (kW per 100 CFM) for precise benchmarking",
                        },
                        {
                            "title": "CO₂ Metrics",
                            "info": "Converts energy savings into verified CO₂ reduction metrics",
                        },
                        {
                            "title": "Complete Integration",
                            "info": "Integrates energy meters, dryers, and flow sensors for a complete system view",
                        },
                        {
                            "title": "Actionable Insights",
                            "info": "Every insight is clear, actionable, and built to help you cut energy costs",
                        },
                    ].map((data) => {
                        return (
                            <div className="case-study-delivers-parent-title-container">
                                <span className="case-study-delivers-parent-title">{data.title}</span>
                                <span className="case-study-delivers-parent-info">{data.info}</span>
                            </div>
                        )
                    })
                    }
                </div>
            </div>
        </div>
    </div>

    {/* <div className="case-study-energy-container">
      <div className="case-study-energy-wrapper">
        <div className="case-study-energy-live-dashboard">
          <span className="case-study-energy-dashboard-title">
            Live Energy Dashboard
          </span>
          <div className="case-study-energy-dashboard-cards">
            {[
              {
                title: "Specific Power Consumption",
                count: "6.8 kW/100CFM",
                info: "Excellent efficiency",
              },
              {
                title: "Load/Unload Ratio",
                count: "3.2:1",
                info: "Optimal performance",
              },
              {
                title: "Energy Saved Today",
                count: "847 kWh",
                info: "$127 cost savings",
              },
            ].map((card, index) => (
              <div key={index}
              className={`case-study-energy-dashboard-card
              ${index === 0 ? "energy-dashboard-card-green" : ""}
              ${index === 1 ? "energy-dashboard-card-blue" : ""}
              ${index === 2 ? "energy-dashboard-card-purple" : ""}
              `}>
                <div className="case-study-energy-dashboard-card-title-container">
                <span className="case-study-energy-card-title">{card.title}</span>
                <span className={`case-study-energy-card-count
                ${index === 0 ? "energy-dashboard-card-count-green" : ""}
                ${index === 1 ? "energy-dashboard-card-count-blue" : ""}
                ${index === 2 ? "energy-dashboard-card-count-purple" : ""}
                    `}>{card.count}</span>
                </div>
                <div class="progress-bar-container">
                    <div class={`progress-bar-fill
                    ${index === 0 ? "progress-bar-fill-green" : ""}
                    ${index === 1 ? "progress-bar-fill-blue" : ""}
                    ${index === 2 ? "progress-bar-fill-purple" : ""}
                    `}></div>
                </div>
                <div className={`case-study-energy-card-info
                ${index === 0 ? "case-study-energy-card-info-green" : ""}
                ${index === 1 ? "case-study-energy-card-info-blue" : ""}
                ${index === 2 ? "case-study-energy-card-info-purple" : ""}
                `}>
                    {card.info}
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="case-study-energy-profile-section">
          <span className="case-study-energy-section-title">
            Transform Your Energy Profile
          </span>
          <span className="case-study-energy-section-subtitle">
            See exactly where your energy goes and how much you can save. Our
            real-time monitoring turns every compressor into a smart, efficient asset.
          </span>
          <ul className="case-study-energy-section-features">
            <li>Instant visibility into energy consumption patterns</li>
            <li>Automated alerts for efficiency opportunities</li>
            <li>Historical trending and benchmarking</li>
            <li>ROI tracking and carbon impact measurement</li>
          </ul>
        </div>
      </div>
    </div> */}

    <div className="case-study-impact-container">
        <div className="case-study-impact-child-container">
            <div className="case-study-impact-title-container">
                <span className="case-study-impact-title">Proven Impact</span>
                <span className="case-study-impact-sub-title">
                    Plants using Kompress.ai typically achieve 10 to 25 percent energy reduction within months of deployment. Here are a few real-world examples that show how visibility turns into measurable savings.
                </span>
            </div>
            <div className="case-study-impact-nested-child-container">
                <div className="case-study-impact-nested-child-left-container">
                    <div className="case-study-impact-nested-child-left-title-container">
                        <span className="case-study-impact-nested-child-left-title">Case Study 1: Global Gear Manufacturer</span>
                        <span className="case-study-impact-nested-child-left-sub-title">Massive Energy Waste Discovered</span>
                    </div>
                    {[
                        {
                            "ques": "Customer Profile",
                            "ans": "A leading manufacturer of gears, gearboxes, and geared motors relies heavily on compressed air for tools, machinery, and quality processes. Their compressors operated independently without coordination, causing energy waste and uneven loading."
                        },
                        {
                            "ques": "What We Found",
                            "ans": "With Kompress.ai, the customer gained full visibility into compressor performance for the first time. In just 15 days of data, one compressor alone wasted 755 kWh which is more than 18 MWh over a year if left unchecked. Unstable discharge pressure was also reducing efficiency across the system."
                        },
                        {
                            "ques": "The Impact",
                            "ans": "By improving the load-to-unload ratio and stabilizing pressure, the customer achieved substantial energy savings and established a path for long-term system efficiency."
                        },
                    ].map((data) => {
                        return (
                            <div className="case-study-impact-nested-child-left-ques-container">
                                <span className="case-study-impact-nested-child-left-ques-title">{data.ques}</span>
                                <span className="case-study-impact-nested-child-left-ques-sub-title">{data.ans}</span>
                            </div>
                        )
                    })
                    }
                </div>
                <div className="case-study-impact-nested-child-right-container">
                    <span className="case-study-impact-nested-child-right-title">Energy Analysis Results</span>
                    <div className="case-study-energy-oppurtunity-child-right-content-container">
                    {[
                        {
                            "title": "Energy Wasted (15 days)",
                            "info": "Single compressor analysis",
                            "count": "755 kWh",
                        },
                        {
                            "title": "Annual Projection",
                            "info": "If left unchecked",
                            "count": "18+ MWh",
                        },
                        {
                            "title": "Load/Unload Ratio",
                            "info": "After optimization",
                            "count": "3:1",
                        },
                        {
                            "title": "Pressure Stability",
                            "info": "System-wide efficiency gain",
                            "count": "Improved",
                        }
                    ].map((data, i) => {
                        return (
                            <div
                            className={`case-study-energy-oppurtunity-child-right-content-parent
                            ${i === 0 ? "right-content-parent-red" : ""}
                            ${i === 1 ? "right-content-parent-yellow" : ""}
                            ${i === 2 ? "right-content-parent-orange" : ""}
                            ${i === 3 ? "right-content-parent-purple" : ""}
                            `}>
                                <div className="case-study-energy-oppurtunity-child-right-content-parent-title-container">
                                    <span className="case-study-energy-oppurtunity-child-right-content-parent-title">{data.title}</span>
                                    <span
                                    className={`case-study-energy-oppurtunity-child-right-content-parent-count
                                    ${i === 0 ? "right-content-count-red" : ""}
                                    ${i === 1 ? "right-content-count-yellow" : ""}
                                    ${i === 2 ? "right-content-count-orange" : ""}
                                    ${i === 3 ? "right-content-count-purple" : ""}
                                    `}>
                                        {data.count}
                                    </span>
                                </div>
                                <span className={`case-study-energy-oppurtunity-child-right-content-parent-info
                                    ${i === 0 ? "right-content-info-red" : ""}
                                    ${i === 1 ? "right-content-info-yellow" : ""}
                                    ${i === 2 ? "right-content-info-orange" : ""}
                                    ${i === 3 ? "right-content-info-purple" : ""}
                                    `}>{data.info}</span>
                            </div>
                        )
                    })
                    
                    }
                </div>
                </div>
            </div>
        </div>
    </div>

        <div className="case-study-impact-container">
        <div className="case-study-impact-child-container">
            <div className="case-study-impact-nested-child-container2">
                <div className="case-study-impact-nested-child-left-container">
                    <div className="case-study-impact-nested-child-left-title-container">
                        <span className="case-study-impact-nested-child-left-title">Case Study 2: 45 kW Compressor Facility</span>
                        <span className="case-study-impact-nested-child-left-sub-title">From Blind Operation to Precision Control</span>
                    </div>
                    {[
                        {
                            "ques": "The Challenge",
                            "ans": "At one site, a 45 kW compressor ran without centralized monitoring. Operators had no visibility into performance, leading to large pressure swings and poor load balance."
                        },
                        {
                            "ques": "The Turning Point",
                            "ans": "Kompress.ai provided real-time data on power, pressure, and load cycles. The customer could finally see how the compressor performed across different shifts."
                        },
                        {
                            "ques": "The Result",
                            "ans": "They optimized compressor use, corrected pressure fluctuations, and reduced pressure variation to less than 0.2 bar. This delivered consistent performance, lower energy costs, and more reliable system operation."
                        },
                    ].map((data) => {
                        return (
                            <div className="case-study-impact-nested-child-left-ques-container">
                                <span className="case-study-impact-nested-child-left-ques-title">{data.ques}</span>
                                <span className="case-study-impact-nested-child-left-ques-sub-title">{data.ans}</span>
                            </div>
                        )
                    })
                    }
                    <div className="case-study-pic-container">
                        <span>The Bigger Picture</span>
                        <span>
                            Hidden waste turned into visible savings. The customer not only improved energy efficiency but also unlocked lasting value from their existing compressors.
                        </span>
                    </div>
                </div>
                <div className="case-study-impact-nested-child-right-container">
                    <span className="case-study-impact-nested-child-right-title">Performance Improvements</span>
                    <div className="case-study-energy-oppurtunity-child-right-content-container">
                    {[
                        {
                            "title": "Before: Pressure Variation",
                            "info": "",
                            "count": "> 1.0 bar",
                        },
                        {
                            "title": "After: Pressure Variation",
                            "info": "",
                            "count": "< 0.2 bar",
                        },
                        {
                            "title": "Real-Time Visibility",
                            "info": "Power, pressure, and load cycles monitored 24/7",
                            "count": "",
                        },
                        {
                            "title": "Consistent Performance",
                            "info": "Reliable operation across all shifts",
                            "count": "",
                        }
                    ].map((data, i) => {
                        return (
                            <div
                            className={`case-study-energy-oppurtunity-child-right-content-parent
                            ${i === 0 ? "right-content-parent-red" : ""}
                            ${i === 1 ? "right-content-parent-yellow" : ""}
                            ${i === 2 ? "right-content-parent-orange" : ""}
                            ${i === 3 ? "right-content-parent-purple" : ""}
                            `}>
                                <div className="case-study-energy-oppurtunity-child-right-content-parent-title-container">
                                    <span className="case-study-energy-oppurtunity-child-right-content-parent-title">{data.title}</span>
                                    <span
                                    className={`case-study-energy-oppurtunity-child-right-content-parent-count
                                    ${i === 0 ? "right-content-count-red" : ""}
                                    ${i === 1 ? "right-content-count-yellow" : ""}
                                    ${i === 2 ? "right-content-count-orange" : ""}
                                    ${i === 3 ? "right-content-count-purple" : ""}
                                    `}>
                                        {data.count}
                                    </span>
                                </div>
                                {(i === 0 || i === 1) &&
                                <div class="progress-bar-container">
                                    <div class={`progress-bar-fill
                                    ${i === 0 ? "progress-bar-fill-red-study2" : ""}
                                    ${i === 1 ? "progress-bar-fill-green" : ""}
                                    `}></div>
                                </div>
                                }
                                <span className={`case-study-energy-oppurtunity-child-right-content-parent-info
                                    ${i === 0 ? "right-content-info-red" : ""}
                                    ${i === 1 ? "right-content-info-yellow" : ""}
                                    ${i === 2 ? "right-content-info-orange" : ""}
                                    ${i === 3 ? "right-content-info-purple" : ""}
                                    `}>{data.info}</span>
                            </div>
                        )
                    })
                    
                    }
                </div>
                </div>
            </div>
        </div>
    </div>


    <div> 
      <div className="case-study-energy-potential-parent-container">
      <div className="case-study-energy-potential-container">
        <span className="case-study-energy-potential-title">See Your True Energy Potential</span>
        <span className="case-study-energy-potential-sub-title">
        Every kilowatt counts. Kompress.ai helps industries capture efficiency, reduce carbon impact, and run smarter through connected intelligence. Your compressors already have the data. Kompress.ai turns it into performance.
        </span>
        <div>
            <button className="case-study-energy-potential-journe-btn">
                Start your Kompress.ai Journey Today!
            </button>
        </div>
      </div></div>
    </div>
    <Footer />
    </React.Fragment>
  )
};

export default CaseStudies;